import { Logo } from './Logo';

const name = 'Logo';
export { Logo, name };

export type { LogoProps } from './types';
